import { render, staticRenderFns } from "./Authors.vue?vue&type=template&id=4ab9ab0c"
import script from "./Authors.vue?vue&type=script&lang=ts"
export * from "./Authors.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports